import { render } from "./CompanyShow.vue?vue&type=template&id=fe80ca4a"
import script from "./CompanyShow.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyShow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Production/Company/CompanyShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe80ca4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe80ca4a', __exports__)) {
    api.reload('fe80ca4a', __exports__)
  }
  
  module.hot.accept("./CompanyShow.vue?vue&type=template&id=fe80ca4a", () => {
    api.rerender('fe80ca4a', render)
  })

}


export default __exports__